<script setup>
import { ref } from 'vue';
import ChainRunner from '@/components/chainRunner/ChainRunner.vue';

const props = defineProps({
  node: Object,
  prompt_chain: Object,
  doc: Object,
  isDialog: { type: Boolean, default: false }
});

const emit = defineEmits(['openDocument', 'accept', 'statusChange', 'closeDialog', 'executionStarted']);

const runnerRef = ref(null);

defineExpose({
  activate: () => runnerRef.value?.activate(),
  resumeActiveGeneration: (id) => runnerRef.value?.resumeActiveGeneration(id)
});
</script>

<template>
  <ChainRunner
    ref="runnerRef"
    :prompt-chain="prompt_chain"
    :node="node"
    :doc="doc"
    :is-dialog="isDialog"
    :show-document-actions="true"
    :enable-regeneration="true"
    :enable-previous-executions="true"
    @accept="(d) => emit('accept', d)"
    @status-change="(s) => emit('statusChange', s)"
    @execution-started="(d) => emit('executionStarted', d)"
    @open-document="(d) => emit('openDocument', d)"
    @close-dialog="emit('closeDialog')"
  />
</template>
